import React from 'react';

import { parseLocaleNumber } from 'Helpers/currencyFormat';

import NumberFormat from 'CommonComponents/LocalisedNumberFormat';

export default function InputsSustainabilityLegacy(props) {
    const changeInput = (e, group, key) => {
        const data = JSON.parse(JSON.stringify(props.data));
        let val = parseLocaleNumber(e.target.value);
        val = Number.isNaN(val) ? 0 : val;

        data[group][key] = val;
        props.changeHandler(data);
    };

    return (
        <div className="table__card">
            <h2 className="table__header tw-mb-6">{$t('Social')}</h2>
            <div className="inbud-table_wrapper">
                <table className="inbud-table">
                    <tbody>
                        <tr>
                            <td>{$t('No. of Female Participants')}</td>
                            <td>
                                <NumberFormat
                                    thousandSeparator={true}
                                    inputMode="numeric"
                                    className="text-input"
                                    value={props.data.diversity_and_inclusion.female_participants}
                                    onChange={(e) => {
                                        changeInput(e, 'diversity_and_inclusion', 'female_participants');
                                    }}
                                />
                            </td>

                            <td>{$t('No. of Male Participants')}</td>
                            <td style={{ width: '35%' }}>
                                <NumberFormat
                                    thousandSeparator={true}
                                    inputMode="numeric"
                                    className="text-input"
                                    value={props.data.diversity_and_inclusion.male_participants}
                                    onChange={(e) => {
                                        changeInput(e, 'diversity_and_inclusion', 'male_participants');
                                    }}
                                />
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    );
}
